module.exports = __webpack_public_path__ + "img/instagram.d452be39.svg";